import { render } from "./ChatInterface.vue?vue&type=template&id=11029489&scoped=true"
import script from "./ChatInterface.vue?vue&type=script&lang=js"
export * from "./ChatInterface.vue?vue&type=script&lang=js"

import "./ChatInterface.vue?vue&type=style&index=0&id=11029489&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11029489"]])

export default __exports__